import { motion } from 'framer-motion';

export default function ModernHero() {
  return (
    <section className="relative h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <motion.div
          initial={{ scale: 1.05 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="w-full h-full"
        >
          <img
            src="https://res.cloudinary.com/ddf1wv47y/image/upload/v1784718521/AE595434-3637-42E7-AFEA-0307C2E0767B_pz16lz.png"
            alt="National emergency response operations"
            className="w-full h-full object-cover"
            loading="eager"
          />
        </motion.div>
        
        {/* Simple Dark Overlay for text readability */}
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="relative z-10 px-4 sm:px-6 lg:px-12 w-full max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="max-w-4xl"
        >
          {/* Typography */}
          <motion.h1 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="font-sans text-4xl md:text-5xl lg:text-7xl font-bold mb-6 leading-tight text-white tracking-tight"
          >
            Protecting Nigeria.<br />
            Empowering Communities.
          </motion.h1>
          
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
            className="text-xl md:text-2xl text-[#F8FAFC] mb-12 max-w-3xl font-light tracking-wide leading-relaxed"
          >
            Together, we're building a Nigeria where every community feels safe, every farmer is protected, and every family can thrive without fear.
          </motion.p>
          
          {/* Buttons */}
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 items-start"
          >
            <a
              href="/programs"
              className="px-8 py-4 text-lg font-semibold text-white bg-[#16A34A] hover:bg-[#15803d] transition-colors duration-300"
            >
              Explore the Initiative
            </a>
            
            <a
              href="/partners"
              className="px-8 py-4 text-lg font-semibold text-white bg-transparent border-2 border-white hover:bg-white hover:text-[#0F172A] transition-colors duration-300"
            >
              Become a Partner
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}